import { render, staticRenderFns } from "./productivity-dashboard.html?vue&type=template&id=1c0ef120&scoped=true&"
import script from "./productivity-dashboard.js?vue&type=script&lang=js&"
export * from "./productivity-dashboard.js?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1c0ef120",
  null
  
)

export default component.exports